"use client";
import { useLayoutEffect, useRef, useState } from "react";
import type { CustomSearchPage } from "..";
import { Sort } from "../searchHead/Sort";
import { Budget } from "./Budget";
import { DesktopSpeakers } from "./DesktopSpeakers";
import { Destinations } from "./Destinations";
import { Duration } from "./Duration";
import { Fit } from "./Fit";
import { Garanti } from "./Garanti";
import { Rythme } from "./Rythme";
import { StartMonths } from "./StartMonths";
import { Themes } from "./Themes";

type Props = {
  travelCount: number;
  customSearchPage?: CustomSearchPage;
};
export const DesktopFilters = ({ travelCount, customSearchPage }: Props) => {
  const listRef = useRef<HTMLDivElement>(null);
  const firstPrimaryRef = useRef<HTMLDivElement>(null);
  const lastPrimaryRef = useRef<HTMLDivElement>(null);
  const [forceBreak, setForceBreak] = useState(true);

  useLayoutEffect(() => {
    const list = listRef.current;
    const first = firstPrimaryRef.current;
    const last = lastPrimaryRef.current;
    if (!list || !first || !last) return;

    const check = () => {
      setForceBreak(last.getBoundingClientRect().top - first.getBoundingClientRect().top < 1);
    };

    check();
    const observer = new ResizeObserver(check);
    observer.observe(list);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="hidden md:flex justify-between items-start mt-2 mb-3 px-2">
      <div ref={listRef} className="flex flex-wrap gap-2 min-w-0 flex-1">
        <div ref={firstPrimaryRef}>
          <Destinations isDesktop />
        </div>
        <Themes isDesktop />
        <StartMonths isDesktop />
        <Duration isDesktop />
        <Budget isDesktop />
        <DesktopSpeakers />
        <div ref={lastPrimaryRef}>
          <Rythme isDesktop />
        </div>
        {forceBreak && <div className="basis-full h-0 w-full" aria-hidden />}
        <div className="flex gap-2">
          <Garanti />
          <Fit />
        </div>
      </div>
      {travelCount !== 0 && !(customSearchPage && customSearchPage.type === "productList") && <Sort />}
    </div>
  );
};
